(function () {
  const widgetUrl = import.meta.env.VITE_WIDGET_URL;
  const currentScript = document.currentScript;
  const params = new URLSearchParams(currentScript?.src.split('?')[1] || '');
  const widgetId = params.get('widgetId') || 'widget-container';

  const iframe = document.createElement('iframe');
  iframe.src = widgetUrl;
  iframe.style.width = '100%';
  iframe.style.border = 'none';
  iframe.style.display = 'block';
  iframe.style.transition = 'height 0.2s ease';
  iframe.setAttribute('allowfullscreen', 'yes');

  const insert = () => {
    const container = document.getElementById(widgetId) || document.body;
    container.appendChild(iframe);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insert);
  } else {
    insert();
  }

  window.addEventListener('message', function (event) {
    if (!event.data || event.data.type !== 'resize-iframe') return;

    iframe.style.height = `${event.data.height}px`;
  });
})();